import { css } from 'styled-components';

import type { ButtonStyleProps } from '/shared/components/widgets/button/buttonTypes';

export default function iconOnlyStyle({ $hasChildren, $hasIcon }: ButtonStyleProps) {
  if (!$hasChildren && $hasIcon) {
    return css`
      padding: 1rem;
      margin: -1rem;
      border-radius: 0;
    `;
  }
}
